import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

const ShowBillFilter = ({
  projects,
  projectSelected,
  projectChanged,
  counters,
  selectedCounter,
  counterChanged,
  getBills,
}) => {
  const cs = counters.value.map((item) => item.water_meter_name);
  return (
    <>
      <div className="container">
        <div className="bills-filter">
          <div className="select-project-wrapper">
            <FormControl sx={{ m: 1, minWidth: 80 }}>
              <InputLabel id="select-project-label">انتخاب پروژه</InputLabel>
              <Select
                labelId="select-project-label"
                id="select-project"
                value={projectSelected.value}
                fullWidth
                label="انتخاب پروژه"
                onChange={projectChanged}
              >
                <MenuItem value="">
                  <em>پروژه مورد نظر را انتخاب کنید.</em>
                </MenuItem>
                {projects.value.map((item) => (
                  <MenuItem value={item.water_meter_project_id}>
                    {item.water_meter_project_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="select-project-wrapper">
            <Autocomplete
              disablePortal
              id="counter-select"
              options={cs}
              sx={{ width: 300 }}
              onChange={counterChanged}
              renderInput={(params) => (
                <TextField {...params} label="انتخاب کنتور" />
              )}
            />
          </div>
          <div className="btn-submit">
            <Button
              variant="contained"
              color="primary"
              disabled={!selectedCounter.value.water_meter_name}
              onClick={getBills}
            >
              جست و جو
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default ShowBillFilter;
